import { Component, OnInit } from '@angular/core';
import { AuthService } from 'services';
import { RoleService } from 'services/role.service';
import { RouterDataResolver } from 'services/router.resolver';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  currentYear = new Date().getFullYear().toString();
  businessName: string = localStorage['businessName'];
  userName: string = localStorage['name']
  isUserLoggedIn = this.authService.isUserLoggedIn.getValue();
   hideSideBar: boolean = false;
  isIndividualUser: boolean = false;
  constructor(private authService: AuthService, private routerDataResolver: RouterDataResolver, private roleService: RoleService) {
    this.hideSideBar =  routerDataResolver.pageName;
   }

  ngOnInit(): void {
    this.isIndividualUser = this.roleService.isIndividualUser;
  }

}
